<template>
  <div class="si-widget si-common-widgets waf-match-info-v2">
    <div
        class="si-masthead-container si-historic-event-cntnr"
        itemscope
        itemtype="https://schema.org/NewsArticle"
    >
      <match-info-head
        :last_updated_label="translations.last_updated_label"
        :pageUrl="getPageUrl()"
        :pageHeadline="generateHeadline()"
        :article_mt_content="formatDateString(story_updated_date, 'article_content', true)"
        :article_mt_meta="formatDateString(story_updated_date, 'article_meta', true)"
        :article_pt_meta="formatDateString(story_created_date, 'article_meta', true)"
      />
      <div v-html="matchStories"></div>
    </div>
  </div>
</template>
<script>
import { getMatch, getMatchImageTitle, getDateString, getMatchInfoTitle } from "../../assets/js/common";
import { CFG_API_DOMAIN, CFG_TEAM_NAME_MAP } from '../../assets/js/config';
import MatchInfoHead from "./MatchInfoHead";
export default {
  data() {
    return {};
  },
  components: {
    MatchInfoHead
  },
  computed: {
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug: {
      get: function () {
        return this.$store.state.match_detail_store.slug;
      },
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    translations() {
      return this.$store.state.translations;
    },
    /**shared state end */
    story_created_date() {
      return this.$store.state.customTipsWidget.story_created_date;
    },
    story_updated_date() {
      return this.$store.state.customTipsWidget.story_updated_date;
    },
    matchStories() {
      return this.$store.state.customTipsWidget.matchStories;
    },
  },
  methods: {
    formatDateString(datestring, type, ignoreTzAddition) {
      let published_time_utc;
      if (typeof datestring === "string") {
        published_time_utc = new Date(datestring);
        let publish_time_ist;
        if (ignoreTzAddition){
          publish_time_ist = published_time_utc;
        } else {
          publish_time_ist = published_time_utc.getTime() + 5.5 * 60 * 60 * 1000;
        }
        if (type === "article_meta") {
          return `${getDateString(
              publish_time_ist,
              "day"
          )} ${getDateString(
              publish_time_ist,
              "month"
          )}, ${getDateString(
              publish_time_ist,
              "year"
          )} ${getDateString(publish_time_ist, "time")} +05:30`;
        } else if (type === "article_content") {
          return `${getDateString(
              publish_time_ist,
              "day_abb"
          )} ${getDateString(
              publish_time_ist,
              "month"
          )}, ${getDateString(
              publish_time_ist,
              "year"
          )} ${getDateString(publish_time_ist, "time")} IST`;
        }
      }
    },
    getPageUrl() {
      let domain = CFG_API_DOMAIN.replace(/\/datafeeds\//, "");
      let path = (this.$store && this.$store.state && this.$store.state.route && this.$store.state.route.path) || '';
      return `${domain}${path}`;
    },
    updateTeamNames() {
      let matchObj = {...this.current_match};
      let { teams } = matchObj;
      let updatedTeams = teams.map((t) => {
        let mapTeam = CFG_TEAM_NAME_MAP.find(tm => tm.city_short === t.short_name);
        if(mapTeam) {
          t.name = mapTeam.official_name
          t.short_name = mapTeam.official_short_name;
        }
        return t;
      });
      matchObj.teams = updatedTeams;
      return matchObj;
    },
    generateHeadline() {
      let matchObj = this.updateTeamNames();
      let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hindi/");
      return getMatchInfoTitle(matchObj, this.translations.match_tips_headline, false, isHindi);
    },
    generateMatchTitle() {
      return getMatchImageTitle(this.current_match);
    },
  },
};
</script>
